import { useRecoilValue } from "recoil"
import { permissionState } from "../../api/state/AuthState"
import { pageState } from "../../state/GlobalState"


export const HasPermission = (permission) => {
    const page = useRecoilValue(pageState)
    const permissions = useRecoilValue(permissionState)
    if(! permission) return true

    permission = permission.startsWith(":") ? permission.substr(1) : `${permission}-${page}`;

    if(permission.startsWith("!")) {
        return !permissions?.includes(permission.substr(1))
    }
    return permissions?.includes(permission)
}